import React, { useEffect, useState } from "react";
import { Formik, Form } from "formik";
import { newRoofTypeSchema } from "../../components/common/validations/Validation";
import TextField from "../../components/common/formInput/TextField";
import { options, message } from "../../components/common/utils/message";
import { alert, confirm } from "react-bootstrap-confirmation";
import { useLocation, useNavigate } from "react-router-dom";
import { failed, success } from "../../components/common/Toastify";
import queryString from 'query-string';
import { useDispatch } from "react-redux";
import TextArea from "../../components/common/formInput/TextArea";
import { addNewRoofType, listNewRoofType, updateNewRoofType } from "../../services/newRoofType";

const NewRoofTypeForm = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();

    const [resPayload, setResPayload] = useState();

    useEffect(() => {
        listNewRoofType({ page: 1 }, (data) => { setResPayload(data) }, dispatch);
    }, []);

    const new_roof_type_id = queryString.parse(location.search)
    const get_new_roof_type = resPayload && resPayload.docs.find((item) => item._id === new_roof_type_id.id)

    const initialData = {
        _id: get_new_roof_type ? get_new_roof_type._id : "",
        roof_type_name: get_new_roof_type ? get_new_roof_type.roof_type_name : "",
        price: get_new_roof_type ? get_new_roof_type.price : "",
        description: get_new_roof_type ? get_new_roof_type.description : "",
    };

    /**
     * @description Function is for add New Roof Type.
     * @param {object} data 
     */
    const _submitData = (data) => {
        try {
            addNewRoofType(data, result => {
                if (result.status === "SUCCESS" && result.code === 200) {
                    success(result.message)
                    navigate("/new-roof-type-list")
                } else if (result.status === "ERROR" && result.code === 403) {
                    failed(result.message)
                }
            }, dispatch)
        } catch (e) {
            failed(e)
        }
    };

    /**
     * @description Function is for Update New Roof Type
     * @param {object} data 
     */
    const _updateData = async (data) => {
        try {
            updateNewRoofType(data, result => {
                if (result.status === "SUCCESS" && result.code === 200) {
                    success(result.message);
                    navigate("/new-roof-type-list")
                } else if (result.status === "ERROR" && result.code === 403) {
                    failed(result.message)
                }
            }, dispatch)
        } catch (e) {
            failed(e)
        }
    };

    /**
     * @description Function is For on Cancel Confirm Box.
     */
    const onCancel = async () => {
        const result = await confirm(message.cancelNewRoofType, options);
        if (result) {
            alert(message.cancelNewRoofType);
            navigate("/new-roof-type-list");
        }
    };

    return (
        <div className="dashboard-inner p-b-0">
            <Formik
                initialValues={initialData}
                enableReinitialize
                validationSchema={newRoofTypeSchema}
                onSubmit={(values) => get_new_roof_type ? _updateData(values) : _submitData(values)}
            >
                {(formik) => (
                    <Form>
                        <div className="d-card m-b-25">
                            <div className="d-card-header">
                                <h5 className="d-card-heading">Add New Roof Type</h5>
                            </div>
                            <div className="d-card-body p-b-0">
                                <div className="form-content">
                                    <div className="f-row alignTop">
                                        <div className="f-33">
                                            <TextField
                                                label="Roof Type Name"
                                                name="roof_type_name"
                                                value={formik?.values?.roof_type_name}
                                                onChange={formik.handleChange}
                                                required={true}
                                            />
                                        </div>
                                        <div className="f-33">
                                            <TextField
                                                label="Price Per Sq Ft"
                                                name="price"
                                                value={formik?.values?.price}
                                                onChange={formik.handleChange}
                                                required={true}
                                            />
                                        </div>
                                    </div>
                                    <div className="f-row alignTop">
                                        <div className="f-66">
                                            <TextArea
                                                label="Roof Description"
                                                name="description"
                                                value={formik?.values?.description}
                                                onChange={formik.handleChange}
                                                required={true}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="d-card-bottom">
                            <div className="d-card-bottom-cell">
                                <button className="btn btn-blue" type="submit">{get_new_roof_type ? "Edit New Roof Type" : "Add New Roof Type"}</button>
                            </div>
                            <div className="d-card-bottom-cell">
                                <button className="btn btn-grey" onClick={onCancel} type="button">
                                    Cancel
                                </button>
                            </div>
                        </div>
                    </Form>
                )}
            </Formik>
        </div>
    );
};

export default NewRoofTypeForm;
